"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onDidLeave = exports.onWillLeave = exports.onDidEnter = exports.onWillEnter = void 0;

var _conductor = require("@virtuous/conductor");

var events = _interopRequireWildcard(require("../constants"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * @param {Function} callback The callback to register.
 */
var onWillEnter = function onWillEnter(callback) {
  (0, _conductor.addCallback)(events.EVENT_WILL_ENTER, callback);
};
/**
 * @param {Function} callback The callback to register.
 */


exports.onWillEnter = onWillEnter;

var onDidEnter = function onDidEnter(callback) {
  (0, _conductor.addCallback)(events.EVENT_DID_ENTER, callback);
};
/**
 * @param {Function} callback The callback to register.
 */


exports.onDidEnter = onDidEnter;

var onWillLeave = function onWillLeave(callback) {
  (0, _conductor.addCallback)(events.EVENT_WILL_LEAVE, callback);
};
/**
 * @param {Function} callback The callback to register.
 */


exports.onWillLeave = onWillLeave;

var onDidLeave = function onDidLeave(callback) {
  (0, _conductor.addCallback)(events.EVENT_DID_LEAVE, callback);
};

exports.onDidLeave = onDidLeave;